<template>
  <div v-if="$store.state.pageLoaded" class="reports-listing">
    <div class="filter-wrapper">
      <md-datepicker v-model="startDate" md-immediately>
        <label>Datum od</label>
      </md-datepicker>
      <md-datepicker v-model="endDate" md-immediately>
        <label>Datum do</label>
      </md-datepicker>
      <md-button class="md-raised md-dense md-primary" v-on:click="getReport">
        Preuzmi
      </md-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data(){
    return{
      startDate: new Date(),
      endDate: new Date()
    }
  },

  methods: {
    getReport(){
      let startYear = this.startDate.getFullYear();
      let startMonth = this.startDate.getMonth()+1;
      let startDay = this.startDate.getDate();
      let endYear = this.endDate.getFullYear();
      let endMonth = this.endDate.getMonth()+1;
      let endDay = this.endDate.getDate();
      this.$store.state.loading = true;
      axios.get(`${this.$store.state.urls.kontoHR}?start_date=${startYear}-${startMonth}-${startDay}&end_date=${endYear}-${endMonth}-${endDay}`, {responseType: 'blob'}).then(response =>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = window.document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['content-disposition'].split("filename=")[1]);
        window.document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.$store.state.loading = false;
      });
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/KontoHR.vue